import agencyAddress from './agencyAddress';
import agency from './agency';
import alertReducer from './alert'; // to not conflict with window.alert
import privacyPolicy from './privacyPolicy';
import region from './region';
import ride from './ride';
import rideDetails from './rideDetails';
import riderAddress from './riderAddress';
import service from './service';
import serviceEstimate from './serviceEstimate';
import serviceGeometries from './serviceGeometries';
import vehiclePosition from './vehiclePosition';

export default {
  agencyAddress,
  agency,
  alert: alertReducer,
  privacyPolicy,
  region,
  ride,
  rideDetails,
  riderAddress,
  service,
  serviceEstimate,
  serviceGeometries,
  vehiclePosition,
};



// WEBPACK FOOTER //
// ./src/ondemand/reducers/index.js